import { createFileRoute } from '@tanstack/react-router'
import CustomNotFound from "@/modules/notFound";
import VerifyAccount from "@/modules/verify";

export const Route = createFileRoute('/verify')({
  component: VerifyAccount,
  notFoundComponent: CustomNotFound
})
